export default "__VITE_ASSET__cYzBo5h2__"